module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./ShoppingCartView.js"));
	}, "ShoppingCartView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ShoppingCartView!./src/pages/Shop/ShoppingCart/ShoppingCartView.js
// module id = 856
// module chunks = 438